import React from 'react';

// Importing icons to match the image
import TrendingUpIcon from '@material-ui/icons/TrendingUp';
import PieChartIcon from '@material-ui/icons/PieChart';
import LayersIcon from '@material-ui/icons/Layers';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';

// --- Data Constants ---

const SUMMARY_METRICS = [
    { label: 'Primary Sales', value: '12.1M cases', delta: '+6% vs plan', tone: 'blue', icon: <TrendingUpIcon />, deltaTone: 'good' },
    { label: 'GT Contribution', value: '62%', delta: '+3 pp', tone: 'green', icon: <PieChartIcon />, deltaTone: 'good' },
    { label: 'Premium Mix', value: '38%', delta: '+4 pp', tone: 'purple', icon: <LayersIcon />, deltaTone: 'good' },
    { label: 'Value Opportunity', value: '₹34 Cr', delta: 'priority gaps', tone: 'orange', icon: <AttachMoneyIcon />, deltaTone: 'warn' },
];

const STATE_CHANNEL_DATA = [
    { state: 'Maharashtra', channel: 'GT', brand: 'Premium A', plan: '620k', runRate: '710k', gap: '+14%', action: 'Protect stock', tone: 'good' },
    { state: 'Karnataka', channel: 'GT', brand: 'Core B', plan: '410k', runRate: '455k', gap: '+11%', action: 'Increase supply', tone: 'good' },
    { state: 'Delhi NCR', channel: 'MT', brand: 'Premium F', plan: '355k', runRate: '390k', gap: '+10%', action: 'Prioritize mix', tone: 'good' },
    { state: 'West Bengal', channel: 'GT', brand: 'Core D', plan: '300k', runRate: '255k', gap: '-15%', action: 'Reduce push', tone: 'bad' },
    { state: 'Telangana', channel: 'GT', brand: 'Value E', plan: '285k', runRate: '335k', gap: '+18%', action: 'Redeploy', tone: 'good' },
];

const COMMERCIAL_OPPORTUNITIES = [
    { exception: 'GT upside', why: 'Run-rate > plan', intervention: 'Increase fill' },
    { exception: 'Premium gap', why: 'Low availability', intervention: 'Prioritize' },
    { exception: 'Slow market', why: 'Demand below plan', intervention: 'Reduce stock' },
    { exception: 'Mix shift', why: 'Premium ↑', intervention: 'Replan production' },
    { exception: 'Distributor gap', why: 'Low offtake', intervention: 'Review' },
];

export class SalesChannels extends React.Component {
    render() {
        return (
            <div className="cc-page">
                {/* Header */}
                <div className="cc-header">
                    <div className="cc-header-text">
                        <h1>Sales & Channel Performance</h1>
                        <p>Connect primary sales, channel mix and availability to identify where GT and premium growth is being won or lost.</p>
                    </div>
                    <div className="cc-header-filters">
                        <button className="cc-filter-btn">Next 8 Weeks</button>
                        <button className="cc-filter-btn">All States</button>
                        <button className="cc-filter-btn">All Brands</button>
                    </div>
                </div>

                {/* Top Metrics Row - Updated to match the image style */}
                <div className="cc-metric-row">
                    {SUMMARY_METRICS.map((metric) => (
                        <div className={`cc-metric-card tone-${metric.tone}`} key={metric.label}>
                            <div className="cc-metric-icon-wrap">{metric.icon}</div>
                            <div className="cc-metric-content">
                                <div className="cc-metric-label">{metric.label}</div>
                                <div className="cc-metric-value">{metric.value}</div>
                                <div className={`cc-metric-delta cc-delta-${metric.deltaTone}`}>
                                    {metric.delta}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Main Content Row */}
                <div className="cc-main-row">
                    {/* Left Panel: State × Channel × Brand Performance */}
                    <div className="cc-panel cc-panel-table">
                        <h2>State × Channel × Brand Performance</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>State</th>
                                    <th>Channel</th>
                                    <th>Brand</th>
                                    <th>Plan</th>
                                    <th>Run-rate</th>
                                    <th>Gap</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {STATE_CHANNEL_DATA.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.state}</td>
                                        <td>{row.channel}</td>
                                        <td>{row.brand}</td>
                                        <td>{row.plan}</td>
                                        <td>{row.runRate}</td>
                                        <td className={`cc-delta-${row.tone}`}>{row.gap}</td>
                                        <td>{row.action}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    {/* Right Panel: Commercial Opportunities (Table) */}
                    <div className="cc-panel cc-panel-table">
                        <h2>Commercial Opportunities</h2>
                        
                        <table className="cc-actions-table cc-table-striped cc-table-light">
                            <thead>
                                <tr>
                                    <th>Exception</th>
                                    <th>Why</th>
                                    <th>Intervention</th>
                                </tr>
                            </thead>
                            <tbody>
                                {COMMERCIAL_OPPORTUNITIES.map((row, index) => (
                                    <tr key={index}>
                                        <td>{row.exception}</td>
                                        <td>{row.why}</td>
                                        <td>{row.intervention}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

export default SalesChannels;